module.exports = __webpack_public_path__ + "img/jesus.0e0803cc.jpg";